var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMagicWand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 13L9.00009 10M14.0104 2.5V1M17.9498 4.06066L19.0104 3M17.9498 12L19.0104 13.0607M10.0104 4.06066L8.94979 3M19.5104 8H21.0104M5.13146 19.8686L14.3687 10.6314C14.7647 10.2354 14.9627 10.0373 15.0369 9.80902C15.1022 9.60817 15.1022 9.39183 15.0369 9.19098C14.9627 8.96265 14.7647 8.76465 14.3687 8.36863L13.6315 7.63137C13.2354 7.23535 13.0374 7.03735 12.8091 6.96316C12.6083 6.8979 12.3919 6.8979 12.1911 6.96316C11.9627 7.03735 11.7647 7.23535 11.3687 7.63137L2.13146 16.8686C1.73545 17.2646 1.53744 17.4627 1.46325 17.691C1.39799 17.8918 1.39799 18.1082 1.46325 18.309C1.53744 18.5373 1.73545 18.7354 2.13146 19.1314L2.86872 19.8686C3.26474 20.2646 3.46275 20.4627 3.69108 20.5368C3.89192 20.6021 4.10827 20.6021 4.30911 20.5368C4.53744 20.4627 4.73545 20.2646 5.13146 19.8686Z",
    stroke: "#17B26A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagicWand);
export default __webpack_public_path__ + "static/media/magic-wand.9f723f4f7b8c4d40094cba39a76a806e.svg";
export { ForwardRef as ReactComponent };